import { render, staticRenderFns } from "./CustomerViewed.vue?vue&type=template&id=c9f6513e"
import script from "./CustomerViewed.vue?vue&type=script&lang=js"
export * from "./CustomerViewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports